import type { TelemetryConfig } from "../types.js";

/**
 * Create an OTLP/HTTP trace exporter configured for the given endpoint.
 * Lazy-loads `@opentelemetry/exporter-trace-otlp-http` so the module is never
 * imported when `provider: "none"`.
 *
 * When both `config.auth` and `config.secretKey` are present, a Basic
 * Authorization header is constructed (base-64 encoded `auth:secretKey`),
 * which is the format expected by Langfuse's OTLP ingestion endpoint.
 *
 * @param config - The resolved {@link TelemetryConfig}. `config.endpoint` must
 *   be set (callers gate on this before calling).
 * @returns A configured `OTLPTraceExporter` instance.
 * @docLink packages/telemetry/concepts#otel-telemetry-provider
 */
export async function createOtlpExporter(config: TelemetryConfig) {
  const { OTLPTraceExporter } = await import("@opentelemetry/exporter-trace-otlp-http");

  const headers: Record<string, string> = {};

  if (config.auth && config.secretKey) {
    const encoded = Buffer.from(`${config.auth}:${config.secretKey}`).toString("base64");
    headers.Authorization = `Basic ${encoded}`;
  }

  return new OTLPTraceExporter({
    url: config.endpoint,
    headers,
  });
}
